import { createSlice } from "@reduxjs/toolkit";
import { PURGE } from "redux-persist";
import {
  hiddenFieldsLoading,
  hiddenFieldsLoaded,
  hiddenFieldsError,
  fieldHidden,
  fieldShown,
  fieldToggleVisibilityInit,
  togglingFieldVisibility,
} from "./hiddenFieldStateActions";
import { ILookupItemModel } from "../../../types/types";

interface HiddenFieldState {
  hiddenFields: ILookupItemModel[];
  loading: boolean;
  error: string | null;
  loaded?: boolean;
  isToggling: boolean;
}

const initialState: HiddenFieldState = {
  hiddenFields: [],
  loading: false,
  error: null,
  loaded: false,
  isToggling: false,
};

const hiddenFieldSlice = createSlice({
  name: "hiddenFields",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
    builder
      .addCase(hiddenFieldsLoading, (state) => {
        state.loading = true;
        state.error = null;
        state.isToggling = false;
      })
      .addCase(hiddenFieldsLoaded, (state, action) => {
        state.loading = false;
        state.loaded = true;
        state.hiddenFields = action.payload;
        state.isToggling = false;
      })
      .addCase(hiddenFieldsError, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isToggling = false;
      })

      .addCase(fieldToggleVisibilityInit, (state, action) => {
        state.loading = false;
        state.error = null;
        state.isToggling = false;
      })
      .addCase(fieldHidden, (state, action) => {
        if (!state.hiddenFields.includes(action.payload)) {
          state.hiddenFields.push(action.payload);
        }
        state.isToggling = false;
      })
      .addCase(fieldShown, (state, action) => {
        state.hiddenFields = state.hiddenFields.filter(
          (field) => field.id !== action.payload
        );
        state.isToggling = false;
      })
      .addCase(togglingFieldVisibility, (state, action) => {
        state.isToggling = true;
      });
  },
});

export default hiddenFieldSlice.reducer;
